// Describes the `disconnect` record /api/quickbooks/status returns when an
// account that used to be connected no longer is. Null when there's no record
// (QuickBooks was never connected) or it has no usable date.
export function describeQuickBooksDisconnect(info) {
  const when = info?.at ? new Date(info.at) : null;
  if (!when || Number.isNaN(when.getTime())) return null;
  const stamp = when.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  if (info.reason === 'disconnected_in_app') {
    return `Disconnected${info.by ? ` by ${info.by}` : ''} on ${stamp}.`;
  }
  return `QuickBooks stopped accepting InteriorFolio's connection on ${stamp}. Reconnect to resume syncing.`;
}
